import styled from 'styled-components'

export const Instructions = styled.p`
  font-size: 16px;
  line-height: 24 px;
  color: #6B7C93;
`

export const SentText = styled.div`
  font-size: 20px;
  line-height: 28 px;
  color: #6B7C93;
`

export const FooterText = styled.div`
  font-size: 14px;
  line-height: 20 px;
  color: #6B7C93;
`

export const SendAgainText = styled.div`
  font-size: 14px;
  line-height: 100%;
  color: #fff;
`

export const HeaderBackground = styled.div`
  background-color: #46ce90;
`



// WEBPACK FOOTER //
// src/components/ForgotPassword/styles.js